"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amenities = exports.radiusUnit = void 0;
var radiusUnit;
(function (radiusUnit) {
    radiusUnit["MILE"] = "MILE";
    radiusUnit["KM"] = "KM";
})(radiusUnit || (exports.radiusUnit = radiusUnit = {}));
var amenities;
(function (amenities) {
    amenities["SWIMMING_POOL"] = "SWIMMING_POOL";
    amenities["SPA"] = "SPA";
    amenities["FITNESS_CENTER"] = "FITNESS_CENTER";
    amenities["AIR_CONDITIONING"] = "AIR_CONDITIONING";
    amenities["RESTAURANT"] = "RESTAURANT";
    amenities["PARKING"] = "PARKING";
    amenities["PETS_ALLOWED"] = "PETS_ALLOWED";
    amenities["AIRPORT_SHUTTLE"] = "AIRPORT_SHUTTLE";
    amenities["BUSINESS_CENTER"] = "BUSINESS_CENTER";
    amenities["DISABLED_FACILITIES"] = "DISABLED_FACILITIES";
    amenities["WIFI"] = "WIFI";
    amenities["MEETING_ROOMS"] = "MEETING_ROOMS";
    amenities["NO_KID_ALLOWED"] = "NO_KID_ALLOWED";
    amenities["TENNIS"] = "TENNIS";
    amenities["GOLF"] = "GOLF";
    amenities["KITCHEN"] = "KITCHEN";
    amenities["ANIMAL_WATCHING"] = "ANIMAL_WATCHING";
    amenities["BABYSITTING"] = "BABY-SITTING";
    amenities["BEACH"] = "BEACH";
    amenities["CASINO"] = "CASINO";
    amenities["JACUZZI"] = "JACUZZI";
    amenities["SAUNA"] = "SAUNA";
    amenities["SOLARIUM"] = "SOLARIUM";
    amenities["MASSAGE"] = "MASSAGE";
    amenities["VALET_PARKING"] = "VALET_PARKING";
    amenities["BAR_OR_LOUNGE"] = "BAR or LOUNGE";
    amenities["KIDS_WELCOME"] = "KIDS_WELCOME";
    amenities["NO_PORN_FILMS"] = "NO_PORN_FILMS";
    amenities["MINIBAR"] = "MINIBAR";
    amenities["TELEVISION"] = "TELEVISION";
    amenities["WIFI_IN_ROOM"] = "WI-FI_IN_ROOM";
    amenities["ROOM_SERVICE"] = "ROOM_SERVICE";
    amenities["GUARDED_PARKG"] = "GUARDED_PARKG";
    amenities["SERV_SPEC_MENU"] = "SERV_SPEC_MENU";
})(amenities || (exports.amenities = amenities = {}));
